export var POPUP_INIT = 'POPUP_INIT';
export var SET_POPUP = 'SET_POPUP';
export var INIT_CLOSE_POPUP = 'INIT_CLOSE_POPUP';
export var CLOSE_POPUP = 'CLOSE_POPUP';
export var INIT_CLOSE_ALL_POPUPS = 'INIT_CLOSE_ALL_POPUPS';
export var CLOSE_ALL_POPUPS = 'CLOSE_ALL_POPUPS';
export var INIT_POPUP_CLOSING_WITH_ANSWER = 'INIT_POPUP_CLOSING_WITH_ANSWER';
export var CLOSING_POPUP_WITH_ANSWER = 'CLOSING_POPUP_WITH_ANSWER';